import { render, staticRenderFns } from "./task-add-or-update.vue?vue&type=template&id=2418d0ef"
import script from "./task-add-or-update.vue?vue&type=script&lang=js"
export * from "./task-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports